import { PHONE_FORMATS } from './constants';

export const formatDocument = (value, type) => {
  const cleanValue = value.replace(/[^0-9]/g, '');
  
  if (type === 'CPF') {
    return cleanValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
  }
  return cleanValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
};

export const formatPhoneNumber = (phone, countryCode) => {
  if (!phone) return '';
  const cleaned = phone.replace(/\D/g, '');
  const formatter = PHONE_FORMATS[countryCode] || PHONE_FORMATS.BR;
  return formatter.mask(cleaned);
};

export const formatCAR = (car) => {
  // First, remove any existing dots
  const cleanCAR = car.replace(/\./g, '');
  
  // Split into state code and the rest using regex
  const match = cleanCAR.match(/^([A-Z]{2})-(\d+)-([A-F0-9]{32})$/i);
  if (!match) return car; // Return original if format is invalid
  
  const [_, stateCode, registrationId, hexPart] = match;
  
  // Format the hex part with dots every 4 characters
  const formattedHex = hexPart.match(/.{4}/g).join('.');
  
  return `${stateCode}-${registrationId}-${formattedHex}`;
};